import List from 'src/storage/messageList';
import { validate } from 'src/helpers/validation';

export class MessageAnalysesModel extends List {
  id = 'MessagesAnalyses';
  defaultState = () => ({
    current: null
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  sortBy = {
    key: 'date',
    desc: true
  };
  apiConfig = {
    refresh: {
      url: 'analyse/refresh',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    list: {
      url: 'analyse/list',
      validation: {
        partnerId: 'userId',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    search: {
      url: 'analyse/search',
      validation: {
        partnerId: 'userId',
        query: 'string',
        skip: 'skip',
        limit: 'limit'
      },
      cancellable: true
    },
    remove: {
      url: '/analyse/remove',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    },
    create: {
      url: 'analyse/create',
      validation: {
        partnerId: 'userId',
        title: 'analyseTitle',
        files: 'analyseFile',
        msgType: 'string'
      },
      cancellable: true
    },
    edit: {
      url: 'analyse/edit',
      validation: {
        id: 'baseId'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount',
    openContact: 'onOpenContact',
    'foxsocket:message:analyse': 'onMessage'
  };

  filterItem = this.onFilterOtherItem;

  listParams(loadMore) {
    const req = {
      partnerId: this.state.partnerId,
      skip: 0,
      limit: this.listLimit,
      doctorIds: this.doctorIds()
    };
    const query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }

  create = (cb) => {
    let { title, files } = this.getCurrent();
    let req = {
      partnerId: this.state.partnerId,
      title,
      files,
      msgType: 'analyse'
    };
    this.api('create', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetAddAnalyse();
        this.filterItem(data);
      }
    });
  };

  edit = (cb) => {
    let { title, files, media, editId } = this.getCurrent();
    let req = {
      id: editId,
      title,
      media,
      files
    };
    let invalid = {
      length: 0,
      title: validate('title', title),
      files: req.media.length > 0 ? null : validate('analyseFile', files)
    };

    invalid.length = Object.values(invalid).filter((v) => !!v).length;

    if (invalid.length > 0) {
      return this.setInvalidApi('edit', invalid);
    }

    this.api('edit', req, (err, data, success) => {
      cb && cb(err, data, success);
      if (success) {
        this.resetAddAnalyse();
        data.notificationFrom = this.state.user?.id;
        this.filterItem(data);
      }
    });
  };

  resetAddAnalyse = (item) => {
    this.resetApiState('edit');
    this.resetApiState('create');
    this.setListState({
      editId: item?.id,
      title: item?.text || '',
      media: item?.media || [],
      files: []
    });
  };

  delete = (item, cb) => {
    this.api('remove', { id: item.id }, (err, data, success) => {
      cb && cb(err, data, success);
    });
  };

  canModify = (item) => {
    const createdById = !item.createdById ? item.from : item.createdById;
    return createdById === this.state.user?.id;
  };
}

const model = new MessageAnalysesModel();
export default model;
